module.exports = __webpack_public_path__ + "img/avatar-1.7c82933d.jpg";